import SystemSettings from './SystemSettings'
import SystemTagManagement from './SystemTagManagement'
import SystemTagManagementSingle from './SystemTagManagementSingle'
import SystemReports from './SystemReports'
import SystemInternManagement from './SystemInternManagement'
import SystemInternManagementInternCreate from './SystemInternManagementInternCreate'
import SystemAdminManagement from './SystemAdminManagement'
import SystemAdminManagementAdminCreate from './SystemAdminManagementAdminCreate'
import SystemCustomNotifications from './SystemCustomNotifications'
import SystemCustomNotificationsList from './SystemCustomNotificationsList'
import SystemCustomNotificationsShowResponse from './SystemCustomNotificationsShowResponse'
import SystemTagTreeManagement from './SystemTagTreeManagement'
import SystemTagNodeManagement from './SystemTagNodeManagement'
import OpportunityManagement from './database/OpportunityManagement'
import DepartmentManagement from './database/DepartmentManagement'
import CategoryManagement from './database/CategoryManagement'
import RegionManagement from './database/RegionManagement'
import ContractManagement from './database/ContractManagement'

export default {
  SystemSettings,
  SystemTagManagement,
  SystemReports,
  SystemAdminManagement,
  SystemAdminManagementAdminCreate,
  SystemInternManagement,
  SystemInternManagementInternCreate,
  SystemTagManagementSingle,
  SystemCustomNotifications,
  SystemCustomNotificationsList,
  SystemCustomNotificationsShowResponse,
  SystemTagTreeManagement,
  OpportunityManagement,
  DepartmentManagement,
  RegionManagement,
  CategoryManagement,
  SystemTagNodeManagement,
  ContractManagement
}
